export const CLIENT_VERSION = "0.1.474";
